import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import DestinationsGrid from "@/components/DestinationsGrid";
import BlogSection from "@/components/BlogSection";
import HowItWorks from "@/components/HowItWorks";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import StickyMobileCta from "@/components/StickyMobileCta";
import SEO from "@/components/SEO";
import { useState, useEffect } from "react";
import AIChat from "@/components/AIChat";

export default function Home() {
  const [chatOpen, setChatOpen] = useState(false);
  const [destination, setDestination] = useState("");
  const [mood, setMood] = useState("");
  const [interest, setInterest] = useState("");

  const handleSearch = (dest, moodKey = "") => {
    setDestination(dest);
    setMood(moodKey);
    setInterest(moodKey || dest);
    setChatOpen(true);
  };

  useEffect(() => {
    const openChat = () => setChatOpen(true);
    window.addEventListener("open-ai-chat", openChat);
    return () => window.removeEventListener("open-ai-chat", openChat);
  }, []);

  return (
    <div className="min-h-screen bg-[var(--vp-bg)]" data-testid="home-page">
      <SEO
        title="Honeymoon & Family Holiday Planner | Vacations Pro"
        description="Plan customized honeymoons and family holidays across India and abroad with Vacations Pro International Private Limited. Founded in 2014."
        path="/"
      />
      <Navbar variant="solid" />
      <Hero onSearch={handleSearch} />
      <HowItWorks />
      <DestinationsGrid onPick={handleSearch} />
      <Testimonials />
      <BlogSection interest={interest} />
      <Footer />
      <AIChat
        open={chatOpen}
        onOpenChange={setChatOpen}
        destination={destination}
        mood={mood}
      />
      <WhatsAppFloat />
      <StickyMobileCta onPlan={() => setChatOpen(true)} />
    </div>
  );
}
